
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';
import SplashPage from '../pages/splash/page';
import LanguagePage from '../pages/language/page';
import LoginPage from '../pages/auth/login/page';
import RegisterPage from '../pages/auth/register/page';
import OTPPage from '../pages/auth/otp/page';
import SearchPage from '../pages/search/page';
import CameraPage from '../pages/camera/page';
import ResultsPage from '../pages/results/page';
import HistoryPage from '../pages/history/page';
import ProfilePage from '../pages/profile/page';
import PaymentPage from '../pages/payment/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SplashPage />
  },
  {
    path: '/language',
    element: <LanguagePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/register',
    element: <RegisterPage />
  },
  {
    path: '/otp',
    element: <OTPPage />
  },
  {
    path: '/home',
    element: <HomePage />
  },
  {
    path: '/search',
    element: <SearchPage />
  },
  {
    path: '/camera',
    element: <CameraPage />
  },
  {
    path: '/results',
    element: <ResultsPage />
  },
  {
    path: '/history',
    element: <HistoryPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/payment',
    element: <PaymentPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
